const state = () => ({
  internalAffairs: [],
  internalAffairPagination: {
    totalResults: 0,
    totalPages: 1,
    prevPage: 1,
    currentPage: 1,
    nextPage: 1,
    perPage: 20
  },
});

const getters = {
  internalAffairs: state => {
    return state.internalAffairs;
  },
  internalAffairPagination: state => {
    return state.internalAffairPagination;
  },
};

const actions = {
  async fetchInternalAffairs({ commit, state }, { currentPage, status }) {
    const { data, headers } = await this.$http.get(`/internal_affairs`, { params: {
        page: currentPage || state.internalAffairPagination.currentPage,
        status,
    }});
    commit("setInternalAffairs", { data, headers });
  },
  async fetchInternalAffair({ commit }, {id}) {
    const { data } = await this.$http.get(`/internal_affairs/${id}`);
    return data;
  },
  async inProgressInternalAffair({ commit, state }, { id, operatorName, message }) {
    await this.$http.post(`/internal_affairs/${id}/in_progress`, { operatorName, message });
  },
  async resolveInternalAffair({ commit, state }, { id, operatorName, message }) {
    await this.$http.post(`/internal_affairs/${id}/write_off`, { operatorName, message });
    commit("refreshInternalAffair", {id});
  },
};

const mutations = {
  setInternalAffairs(state, { data, headers }) {
    state.internalAffairs = data;
    state.internalAffairPagination.totalResults = +headers["x-total-results"];
    state.internalAffairPagination.totalPages = +headers["x-total-pages"];
    state.internalAffairPagination.prevPage = +headers["x-total-pages"];
    state.internalAffairPagination.currentPage = +headers["x-current-page"];
    state.internalAffairPagination.nextPage = +headers["x-next-page"];
    state.internalAffairPagination.perPage = +headers["x-per-page"];
  },
  refreshInternalAffair(state, data) {
    state.internalAffairs.splice(state.internalAffairs.findIndex(a => a.id === data.id), 1);
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
